<div class="text-sm font-medium italic">
  <span
    appIcon
    name="info"
    [size]="18"
    class="inline-block align-middle pb-1 text-primary"></span>
  <ng-content />
</div>
